import { render } from "./OrdemProducaoIndex.vue?vue&type=template&id=33558c0b&scoped=true&ts=true"
import script from "./OrdemProducaoIndex.vue?vue&type=script&lang=ts"
export * from "./OrdemProducaoIndex.vue?vue&type=script&lang=ts"

import "./OrdemProducaoIndex.vue?vue&type=style&index=0&id=33558c0b&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33558c0b"]])

export default __exports__